var React = require('react');

function StepCircle0248px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m5.291 32v-1.898h-7.566v-.052l1.326-1.248c3.562-3.432 5.824-5.954 5.824-9.074 0-2.418-1.534-4.914-5.148-4.914-1.95 0-3.64.754-4.784 1.716l.728 1.612c.78-.65 2.054-1.43 3.588-1.43 2.522 0 3.328 1.586 3.328 3.302 0 2.548-1.976 4.732-6.292 8.84l-1.794 1.742V32h10.79z"}));
}

StepCircle0248px.displayName = "StepCircle0248px";

StepCircle0248px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0248px;

StepCircle0248px.default = StepCircle0248px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-02-48px.svg
// module id = 1153
// module chunks = 0